module.exports = __webpack_public_path__ + "assets/img/page_2.ca3e7a99.png";